<ng-container *ngIf="Opened">
    <div class="bonbell-nodata ViewAll__nodata">
        <img src="'../../../../../assets/img/No_Data.png" alt="">
        <p class="nodata-text">{{'lang_no_data' | language}}</p>
    </div>
</ng-container>